/* eslint-disable */
import React from 'react';
// import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function StaffBanner() {
    return (
        <>
            <div className="banner">
                <img
                    src='../../assets/images/Staffing.jpg'
                    alt="Virtual assistant staffing solutions"
                    title="Remote Staffing Services by ConnectMyVA"
                    className="bannerImage"
                />			
            </div>
        </>
    );
}

export default StaffBanner;
